(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gd-best-of-dallas-vote"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__gdBestOfDallasVoteTracking)return;
  window.__gdBestOfDallasVoteTracking=true;
  document.addEventListener('click',function(event){
    var target=event.target;
    if(!target||!target.closest)return;
    var link=target.closest('[data-gd-intent="vote"]');
    if(!link)return;
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({
      event:'gd_vote_intent',
      campaign:link.dataset.gdCampaign||'best-of-dallas-2026',
      placement:link.dataset.gdPlacement||'unknown',
      link_url:link.href,
      link_text:(link.textContent||'').trim(),
      page_path:window.location.pathname
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gd-collect-ui"] && !Shopify.designMode) return;
  try {
    function initCollect(root=document){
  root.querySelectorAll('[data-gdc-gallery]').forEach(gallery=>{
    if(gallery.dataset.gdcReady)return;
    gallery.dataset.gdcReady='true';
    const cards=[...gallery.querySelectorAll('[data-gdc-card]')].sort((a,b)=>Number(a.dataset.order)-Number(b.dataset.order)),search=gallery.querySelector('[data-gdc-search]'),artist=gallery.querySelector('[data-gdc-artist]'),category=gallery.querySelector('[data-gdc-category]'),grid=gallery.querySelector('.gdc-grid');
    cards.forEach(card=>grid.append(card));
    [[artist,'artist'],[category,'category']].forEach(([select,key])=>[...new Set(cards.flatMap(card=>key==='artist'?card.dataset.artist.split(' & '):[card.dataset[key]]))].filter(Boolean).sort((a,b)=>a.localeCompare(b)).forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option);}));
    const params=new URLSearchParams(location.search),size=Number(gallery.dataset.pageSize)||24,pager=gallery.querySelector('[data-gdc-pagination]');
    let page=Math.max(1,Number(params.get('art_page'))||1),matched=[];
    search.value=params.get('q')||'';artist.value=params.get('artist')||'';category.value=params.get('medium')||'';
    const counter=gallery.querySelector('[data-gdc-count]');
    function filter(){const term=search.value.trim().toLocaleLowerCase();matched=cards.filter(card=>(!artist.value||card.dataset.artist.split(' & ').includes(artist.value))&&(!category.value||card.dataset.category===category.value)&&(!term||card.dataset.search.includes(term)));const pages=Math.max(1,Math.ceil(matched.length/size));page=Math.min(page,pages);const shown=new Set(matched.slice((page-1)*size,page*size));cards.forEach(card=>card.hidden=!shown.has(card));counter.textContent=matched.length+' '+counter.dataset.label;gallery.querySelector('[data-gdc-empty]').hidden=matched.length>0;pager.hidden=pages<2;pager.querySelector('[data-gdc-prev]').disabled=page===1;pager.querySelector('[data-gdc-next]').disabled=page===pages;pager.querySelector('[data-gdc-page]').textContent=page+' / '+pages;}
    function update(reset=true){if(reset)page=1;filter();const url=new URL(location.href);[['q',search.value.trim()],['artist',artist.value],['medium',category.value],['art_page',page>1?String(page):'']].forEach(([key,value])=>value?url.searchParams.set(key,value):url.searchParams.delete(key));history.replaceState(null,'',url);}
    search.addEventListener('input',()=>update());artist.addEventListener('change',()=>update());category.addEventListener('change',()=>update());gallery.querySelector('[data-gdc-reset]').addEventListener('click',()=>{search.value='';artist.value='';category.value='';update();search.focus();});
    [[pager.querySelector('[data-gdc-prev]'),-1],[pager.querySelector('[data-gdc-next]'),1]].forEach(([button,step])=>button.addEventListener('click',()=>{page+=step;update(false);gallery.querySelector('.gdc-filters').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));filter();
  });
}
document.addEventListener('click',event=>{const link=event.target.closest('[data-gdc-interest]');if(link){const form=document.querySelector('#artwork-inquiry form');if(form){const select=form.querySelector('select');select.value=link.dataset.gdcInterest;}}});
document.addEventListener('shopify:section:load',event=>initCollect(event.target));
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initCollect(),{once:true});else initCollect();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gd-presence-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.GDPresenceTrackingInitialized || window.Shopify?.designMode) return;
  window.GDPresenceTrackingInitialized = true;
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const pendingPrefix = 'gd-presence-pending:';
  const memory = new Map();
  let privacy = null;
  let artistViewed = false;

  function allowed() {
    try { return privacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }

  function readStorage(key) {
    if (!allowed()) return null;
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; }
  }

  function writeStorage(key, value) {
    if (!allowed()) return;
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(value));
    } catch (_) { return; }
  }

  function campaignFrom(url) {
    const result = {};
    for (const key of utmKeys) {
      const value = url.searchParams.get(key);
      if (value && /^[a-zA-Z0-9_.-]{1,100}$/.test(value)) result[key] = value;
    }
    return result;
  }

  function attribution(url) {
    const incoming = campaignFrom(new URL(location.href));
    const previous = readStorage('gd-presence-campaign') || {};
    if (Object.keys(incoming).length) writeStorage('gd-presence-campaign', incoming);
    const current = Object.keys(incoming).length ? incoming : previous;
    return { ...current, ...(url ? campaignFrom(url) : {}) };
  }

  function emit(name, details = {}) {
    if (!allowed()) return false;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      gd_event_version: '2026-10-26',
      page_path: location.pathname,
      placement: null,
      link_url: null,
      artist_name: null,
      artist_handle: null,
      inquiry_type: null,
      form_id: null,
      gd_event_id: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_content: null,
      utm_term: null,
      ...attribution(),
      ...details
    });
    return true;
  }

  function formKind(form) {
    const declared = form.dataset.gdFormKind;
    if (['email', 'artwork', 'private_event', 'field_trip'].includes(declared)) return declared;
    if (form.querySelector('input[name="form_type"][value="customer"]')) return 'email';
    const type = form.querySelector('[name="contact[Inquiry type]"]')?.value || '';
    if (/private event|venue hire|corporate event|birthday|gala|wedding/i.test(type)) return 'private_event';
    if (/field trip|school visit/i.test(type)) return 'field_trip';
    if (/artwork|art collection/i.test(type)) return 'artwork';
    if (form.querySelector('[name="contact[interest]"]')?.value === 'Collect') return 'artwork';
    if (form.querySelector('input[name="form_type"][value="contact"]')) return 'inquire';
    return null;
  }

  function pendingKey(form) {
    return pendingPrefix + location.pathname + ':' + form.id;
  }

  function rememberSubmission(event) {
    const form = event.target;
    if (!allowed() || !(form instanceof HTMLFormElement) || !form.id || !form.checkValidity()) return;
    const kind = formKind(form);
    if (!kind) return;
    const record = {
      kind,
      form_id: form.id,
      time: Date.now(),
      event_id: window.crypto?.randomUUID?.() || String(Date.now()) + '-' + Math.random().toString(36).slice(2)
    };
    const key = pendingKey(form);
    memory.set(key, record);
    writeStorage(key, record);
  }

  function confirmedForms() {
    if (!allowed()) return;
    document.querySelectorAll('[data-gd-analytics-success], [data-gd-form-success]').forEach(marker => {
      if (marker.dataset.gdAnalyticsRecorded === 'true') return;
      const form = marker.closest('form') || document.getElementById(marker.dataset.gdFormId || '');
      if (!(form instanceof HTMLFormElement) || !form.id) return;
      const key = pendingKey(form);
      const record = memory.get(key) || readStorage(key);
      if (!record || record.form_id !== form.id || Date.now() - record.time > 1800000) return;
      const kind = record.kind;
      const details = { form_id: form.id, inquiry_type: kind, gd_event_id: record.event_id };
      const eventName = kind === 'email' ? 'email_signup' : 'inquire_submit';
      if (!emit(eventName, details)) return;
      const specific = { artwork: 'artwork_inquire', private_event: 'private_event_inquire', field_trip: 'field_trip_request' }[kind];
      if (specific) emit(specific, details);
      marker.dataset.gdAnalyticsRecorded = 'true';
      memory.delete(key);
      writeStorage(key, null);
    });
  }

  function artistPage() {
    if (artistViewed || !allowed()) return;
    const artist = document.querySelector('[data-gd-artist-page]');
    if (!artist || !artist.dataset.gdArtistName) return;
    artistViewed = emit('artist_page_view', {
      artist_name: artist.dataset.gdArtistName,
      artist_handle: artist.dataset.gdArtistHandle || ''
    });
  }

  function ticketClick(event) {
    if (!allowed() || !(event.target instanceof Element)) return;
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.protocol !== 'https:' || url.hostname !== 'tickets.gallerydefi.io') return;
    emit('ticket_click', {
      link_url: url.origin + url.pathname,
      placement: link.dataset.gdPlacement || campaignFrom(url).utm_content || link.closest('section, header, footer')?.id || 'page',
      ...attribution(url)
    });
  }

  function scan() {
    if (!allowed()) return;
    attribution();
    artistPage();
    confirmedForms();
  }

  function inquiryClick(event) {
    if (!allowed() || !(event.target instanceof Element)) return;
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest('a[data-gd-intent][href]');
    const eventName = {
      artwork_inquiry: 'artwork_inquiry_click',
      private_event_inquiry: 'private_event_inquiry_click'
    }[link?.dataset.gdIntent];
    if (!eventName) return;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    emit(eventName, {
      link_url: url.origin + url.pathname,
      placement: link.dataset.gdPlacement || 'page',
      inquiry_type: link.dataset.gdIntent === 'artwork_inquiry' ? 'artwork' : 'private_event'
    });
  }

  function synchronizeConsent() {
    const ready = window.GDPrivacy?.ready();
    if (!ready) return;
    ready.then(value => {
      privacy = value;
      if (!allowed()) {
        memory.clear();
        try {
          Object.keys(sessionStorage).filter(key => key.startsWith('gd-presence-')).forEach(key => sessionStorage.removeItem(key));
        } catch (_) { return; }
        return;
      }
      scan();
    });
  }

  document.addEventListener('submit', rememberSubmission, true);
  document.addEventListener('click', ticketClick, true);
  document.addEventListener('auxclick', ticketClick, true);
  document.addEventListener('click', inquiryClick, true);
  document.addEventListener('auxclick', inquiryClick, true);
  document.addEventListener('visitorConsentCollected', synchronizeConsent);
  document.addEventListener('shopify:section:load', scan);
  window.addEventListener('pageshow', synchronizeConsent);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', synchronizeConsent, { once: true });
  else synchronizeConsent();
})();
  } catch(e) { console.error(e); }
})();

})();
